/**
 * Premium Dark Mode Toggle Component
 * Skeuomorphic toggle integrating with existing theme system
 */
class DarkModeTogglePremium extends HTMLElement {
  connectedCallback() {
    // Find the checkbox within this element
    this.checkbox = this.querySelector('.theme-switch__checkbox');
    
    if (this.checkbox) {
      // Initialize checkbox state to match current theme
      this.syncCheckboxState();

      // Add change event listener
      this.checkbox.addEventListener('change', () => this.handleToggle());

      // Listen for theme changes from other toggle buttons
      window.addEventListener('theme-change', () => this.syncCheckboxState());

      // Detect system theme preference changes
      if (window.matchMedia) {
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
          if (!localStorage.getItem('theme')) {
            this.syncCheckboxState();
          }
        });
      }
    }
  }

  syncCheckboxState() {
    const currentTheme = document.documentElement.getAttribute('data-theme');
    const isDark = currentTheme === 'dark';
    this.checkbox.checked = isDark;
  }

  handleToggle() {
    const isDark = this.checkbox.checked;
    const newTheme = isDark ? 'dark' : 'light';

    // 1. Update HTML attribute
    document.documentElement.setAttribute('data-theme', newTheme);

    // 2. Save to localStorage
    localStorage.setItem('theme', newTheme);

    // 3. Dispatch custom event for other components
    window.dispatchEvent(new CustomEvent('theme-change', { detail: { theme: newTheme } }));

    // 4. Haptic feedback (if available)
    this.triggerHapticFeedback();
  }

  triggerHapticFeedback() {
    try {
      if (navigator.vibrate) {
        navigator.vibrate(15);
      } else if (window.webkit?.messageHandlers?.hapticFeedback) {
        window.webkit.messageHandlers.hapticFeedback.postMessage({});
      }
    } catch (e) {
      // Silently fail if haptic is not available
    }
  }
}

// Define the custom element - wraps the label
customElements.define('dark-mode-toggle-premium', DarkModeTogglePremium);
